// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'vue-beauty/package/style/vue-beauty.min.css';
import '@/assets/css/common.less';
import 'highlight.js/styles/atom-one-light.css';
import Vue from 'vue';
import vueBeauty from 'vue-beauty';
import App from './App';
import router from './router';
import store from './store';
import pub from './assets/js/pub';
import http from './assets/js/http';
import constants from './assets/js/constants';
import SuccessModal from './components/SuccessModal';
import FailModal from './components/FailModal';
import {
    Table,
    TableColumn,
    Dialog,
    Form,
    Input,
    Select,
    Icon,
    Tooltip,
    Radio,
    Option,
    FormItem,
    Button,
    Popover,
    Message,
    Checkbox,
    CheckboxGroup,
    Pagination,
    Empty,
    MessageBox,
    Loading,
    Divider,
    Tabs,
    TabPane,
    card,
    Timeline,
    TimelineItem,
    Link,
    DatePicker
} from 'element-ui';
import './assets/css/element-variables.scss';
import * as echarts from 'echarts';

Vue.prototype.$echarts = echarts;

Vue.config.productionTip = false;


TableColumn.props.showOverflowTooltip = {
    default: true,
    type: Boolean,
};
// 添加复制功能
// eslint-disable-next-line func-names
Table.components.TableBody.methods.handleDoubleClick = function (event, row) {
    console.log(event.target.innerText);
    const selection = document.getSelection();
    const range = document.createRange();
    range.selectNode(event.target);
    selection.removeAllRanges();
    selection.addRange(range);

    document.execCommand('copy');// 执行copy方法

    this.handleEvent(event, row, 'dblclick');
};


Vue.use(vueBeauty)
    .use(pub)
    .use(http)
    .use(constants)
    .use(SuccessModal)
    .use(FailModal)
    .use(Table)
    .use(TableColumn)
    .use(Dialog)
    .use(Form)
    .use(Input)
    .use(Select)
    .use(Icon)
    .use(Tooltip)
    .use(Radio)
    .use(Option)
    .use(FormItem)
    .use(Button)
    .use(Popover)
    .use(Checkbox)
    .use(CheckboxGroup)
    .use(Pagination)
    .use(Empty)
    .use(Divider)
    .use(Tabs)
    .use(TabPane)
    .use(Loading)
    .use(card)
    .use(TimelineItem)
    .use(Timeline)
    .use(Link)
    .use(DatePicker);

Vue.$_message = Vue.prototype.$_message = Message;
Vue.$confirm = Vue.prototype.$confirm = MessageBox.confirm;
Vue.$alert = Vue.prototype.$alert = MessageBox.alert;
Vue.$prompt = Vue.prototype.$prompt = MessageBox.prompt;

window.openNew = ((url) => {
    const dom = document.createElement('a');
    dom.setAttribute('href', url);
    dom.setAttribute('target', '_blank');
    document.body.appendChild(dom);
    dom.click();
});

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    template: '<App/>',
    components: { App },
});



// WEBPACK FOOTER //
// ./src/main.js